<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<upload :value="invoicefile" ref="upload" :formCreateInject="true" />
			</template>
			<template #footer>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			row: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_title: '上传发票',
				modal_width: 500,
				modal_height: 500,
				invoicefile:[]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			modal_init(){
				this.invoicefile = this.row.invoicefile?JSON.parse(JSON.stringify(this.row.invoicefile)):[]
				
			},
			submit() {
				let invoicefile = this.$refs.upload.value
				if(invoicefile.length==0){
					this.$message.error('请上传图片')
					return
				}
				this.$api.paymentapplication.updatefromlist(this.row.id, {
					invoicefile: invoicefile
				}).then(() => {
					this.$message.success('上传成功')					
					this.modal_cancel()
				})
				
				
				//console.log(this.row, this.$refs.upload.value)
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			upload
		}
	}
</script>